<template>
  <div style="height: 100%;">
    <v-container fluid style="overflow: auto; height: 100% !important; padding-bottom: 0px;">
        <v-data-table
          :headers="headers"
          :items="userList"
          sort-by=""        
          fixed-header  
          dense      
          id="userTable"  
          height="75%"
        >
          <!-- <template v-slot:[`item.start_time`]="{ item }">
            {{ formatDateTime(item.start_time) }}
          </template> -->
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="font-weight-bold"
                >User Management
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div class="d-flex flex-row" style="gap: 7px;">
                <v-btn @click="userLog" small elevation="" color="blue-grey lighten-4">
                  <img class="btn log" src="@/assets/history.svg">
                  log
                </v-btn>
                <v-btn small elevation="" @click="createPopup('create', null)" color="orange" style="color: white !important;">
                  CREATE
                </v-btn>
              </div>
            </v-toolbar>
          </template>
          <template v-slot:[`item.active_status`]="{ item }">
            <div class="d-flex justify-center align-center">
              <!-- <div v-if="item.active_status==1" class="chip" style="background-color: #4CAF50;">
              </div>
              <div v-else class="chip" style="background-color: #FF5722;"> 
              </div> -->
              <v-container
                class="pa-0 ma-0 d-flex justify-center align-center"
                fluid
              >
                <v-switch
                  :input-value="item.active_status"
                  color="success"
                  inset
                  dense
                  @change="(newVal)=>switchStatus(item, newVal)"
                ></v-switch>
              </v-container>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top nudge-top="-3" tag="div">
              <template v-slot:activator="{ on, attrs }">
                <img
                  src="@/assets/pencil.svg"
                  class="btn"
                  v-bind="attrs"
                  v-on="on"
                  @click="createPopup('edit', item)"
                />
              </template>
              <div class="text-caption">Edit</div>
            </v-tooltip>
            <!-- <v-tooltip top nudge-top="-3" tag="div">
              <template v-slot:activator="{ on, attrs }">
                <img
                  src="@/assets/delete.svg"
                  class="btn"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteUser(item)"
                />
              </template>
              <div class="text-caption">Inactive</div>
            </v-tooltip> -->
          </template>
        </v-data-table>
    </v-container>
    <v-overlay
      v-if="showSelf" @close="showSelf = false"
    >
      <userCreate v-if="showSelf" :type="createEdit" :userData="userData"></userCreate>
    </v-overlay>
    <v-overlay
      v-if="showLog"
    >
      <userLog v-if="showLog" :logData="logData"></userLog>
    </v-overlay>
    
    <!-- <div 
    v-if="addUser"
    class="d-flex justify-center align-center"
    style="position: absolute; top: 0px; width: 100%; height: 100%;  background-color: rgb(33, 33, 33);"
    >
    <userCreate></userCreate>
  </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import userCreate from '@/manage/userCreate.vue';
import EventBus from '@/plugins/EventBus';
import userLog from '@/manage/userLog.vue';
import Swal from 'sweetalert2';

export default {
    name: 'UserManage',
    components:{
      userCreate,
      userLog
    },
    data(){
        return {
            headers: [
              { text: "Name", value: "username", align: "center" },
              { text: "Email", value: "email", sortable: false, align: "center" },
              { text: "Role", value: "group", align: "center" },
              { text: "Status", value: "active_status", sortable: false, align: "center" },
              { text: "Validity Period", value: "valid", sortable: false, align: "center" },
              { text: "Last Login", value: "last_login", sortable: false, align: "center" },
              { text: "Actions", value: "actions", sortable: false, align: "center" }
            ],
            userList:[],
            addUser: false,
            showSelf: false,
            userData: null,
            logData: null,
            showLog: false,
        }
    },
    created(){
      this.getUserList();
      EventBus.$on('createClose', this.showPopup)
      EventBus.$on('closeLog', this.closeLog)
    
    },
    methods:{
      getUserList:function(){
        axios.post(`${this.$apiUrl}/manage/userlist`,{},{ withCredentials: true })
        .then((res)=>{
          console.log(res)
          if(!res.data.error){
            this.userList = res.data.map((x)=>{
              return {
                username: x.username,
                email: x.email,
                active_status: x.active_status,
                group: x.group || '-',
                valid: this.validDate(x.user_start_date, x.user_expire_date),
                last_login: this.fomatDate(x.last_login),
                user_id: x.id
              }
            })
          }
        })
      },
      showPopup:function(){
        this.showSelf=false;
        this.getUserList();
      },
      validDate:function(date1, date2){
        if(date1 || date2){
          return  `${this.fomatDate(date1)}~${this.fomatDate(date2)}`
        }else{
          return '-'
        }
      },
      fomatDate(string){
        const date = new Date(string);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
        const dd = String(date.getDate()).padStart(2, '0');
        return string? `${yyyy}.${mm}.${dd}`: '-';
      },
      createPopup:function(type, item){
        this.showSelf = !this.showSelf
        if(type=='create'){
          this.createEdit = 'create'
        }else{
          console.log(item)
          this.createEdit = 'edit'
          this.userData = item.user_id
        }
      },
      deleteUser:function(item){
        console.log("deleteUser"+item);
      },
      userLog:function(){
        axios.post(`${this.$apiUrl}/manage/userlog`,{},{withCredentials: true})
        .then((res)=>{
          this.logData = res.data.result
          this.showLog = true;
        })
      },
      closeLog:function(){
        this.showLog = false;
      },
      switchStatus:function(item, newVal){
        console.log(item.active_status)
        if(item.active_status){
          Swal.fire({
              title: 'Confirm User Deactivation',
              text: "This action will deactivate this user and restrict their access to the system. Are you sure you want to proceed?",
              icon: 'warning',
              width: '400px',
              showCancelButton:true,
              confirmButtonText:'Yes',
              confirmButtonColor: '#FF9800',
              cancelButtonText:'Cancel',
              customClass:{
                  confirmButton: 'custom-confirm-button'
              }
          }).then((result)=>{
            if(result.isConfirmed){
                console.log(result)
                axios.post(`${this.$apiUrl}/manage/userstatus`,{
                  user_id: item.user_id
                },{
                  withCredentials: true
                }).then((res)=>{
                  if(res.data.result){
                    this.getUserList();
                  }
                })
            }else{
              item.active_status = !newVal;
            }
          })
        }else{
          Swal.fire({
              title: 'Confirm User activation',
              text: "This action will activate this user and the user can access to the system. Are you sure you want to proceed?",
              icon: 'warning',
              width: '400px',
              showCancelButton:true,
              confirmButtonText:'Yes',
              confirmButtonColor: '#FF9800',
              cancelButtonText:'Cancel',
              customClass:{
                  confirmButton: 'custom-confirm-button'
              }
          }).then((res)=>{
            if(res.isConfirmed){
               axios.post(`${this.$apiUrl}/manage/userstatus`,{
                  user_id: item.user_id
                },{
                  withCredentials: true
                }).then((res)=>{
                  if(res.data.result){
                    this.getUserList();
                  }
                })
            }else{
              item.active_status = !newVal
            }
          })
        }
      }
    },
    beforeDestroy(){
      EventBus.$off('createClose')
      EventBus.$off('closeLog')
    }
}
</script>

<style>
.v-overlay__content{
  height: 90vh;
}
.btn {
  width: 20px;
  height: 20px;
  filter: invert(66%) sepia(8%) saturate(576%) hue-rotate(155deg)
    brightness(95%) contrast(94%);
}

.log{
  filter: invert(0%) sepia(7%) saturate(12%) hue-rotate(293deg) brightness(96%) contrast(100%);
}

.chip{
  width: 20px;
  height: 15px;
  border-radius: 20px;
}
.v-overlay{
  position: absolute;
  left: 0;
  top: 0;
}

#userTable{
  height: 100% !important;
}

#userTable .v-data-table__wrapper{
  scrollbar-width: none;
}
#userTable .v-data-table__wrapper::-webkit-scrollbar{
  display: none;
 }

@media (max-width:800px){
  .v-overlay__content{
    width: 100% !important;
  } 
}

</style>